export type dataTable = {
  codification: string;
  id: string;
  materialId: string;
  name: string;
  subCodification: string;
  typeOfMeasurement: string;
  // Materiales por equipo (2026-07-31). Vacío = disponible para todos.
  teamIDs?: string[];
  teamNames?: string[];
  /**
   * Baja lógica del catálogo (2026-08-31). El loader lo normaliza a booleano:
   * 🔴 AUSENTE o `null` en el servidor = ACTIVO.
   */
  isActive?: boolean;
};

export type TableProps = {
  data?: {
    /** Catálogo completo. Lo consume el buscador y el modal de equipos. */
    materials: dataTable[];
    activeMaterials?: dataTable[];
    inactiveMaterials?: dataTable[];
  };
  onEditMaterialTeams?: (material: dataTable) => void;
  /** Baja lógica. Si no llega, la tabla no ofrece mover filas. */
  onDeactivate?: (id: string) => void;
  onActivate?: (id: string) => void;
};

export type SearchbarFilterTypes = (value: string) => void;

export const materialsColumnNames = {
  materialId: {
    id: 'materialId',
    label: 'Codi',
  },
  name: {
    id: 'name',
    label: 'Material',
  },
  codification: {
    id: 'codification',
    label: 'Codificació',
  },
  subCodification: {
    id: 'subCodification',
    label: 'Subcodificació',
  },
  typeOfMeasurement: {
    id: 'typeOfMeasurement',
    label: 'Um.',
  },
  teams: {
    id: 'teams',
    label: 'Equips',
  },
};
